import { isAuthenticated } from '@/helpers/utils';
import authRoutes from '@/modules/authentication/routes';
import globalRoutes from '@/modules/global/routes';
import complaintsRoutes from '@/modules/complaints/routes';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    ...authRoutes,
    ...globalRoutes,
    ...complaintsRoutes,
    {
      path: '*',
      redirect: '/error/404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  Vue.appLoader.start();
  if (to.hash === '##') {
    next(false);
    Vue.appLoader.end();
    return;
  }
  if (!to.meta.isPublic && !isAuthenticated()) {
    return next({
      path: '/auth',
      query: { redirect_url: to.fullPath },
    });
  }

  next();
});

router.afterEach(() => {
  Vue.appLoader.end();
});

export default router;
